module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right_column"
  }, [_c('general-schedule', {
    attrs: {
      "initialState": {
        dayCount: this.dayCount
      },
      "doctorList": _vm.doctorList,
      "agendaList": _vm.agendaList,
      "updateAgenda": _vm.updateAgenda
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e649110"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/GeneralSchedue/GeneralSchedule.vue
// module id = 627
// module chunks = 0